import React, { createContext, useState } from "react";
import Modal from "../components/elements/Modal/Modal";
import useModal from "../hooks/useModal";

const ModalContext = createContext();
const { Provider } = ModalContext;

const ModalProvider = ({ children }) => {
  const { modal, handleModal, modalContent } = useModal();
  const [data, setData] = useState([]);
  return (
    <Provider value={{ modal, handleModal, modalContent, data, setData }}>
      <Modal />
      {children}
    </Provider>
  );
};

export { ModalContext, ModalProvider };
